import styled from 'styled-components';
import ListItem from '@mui/material/ListItem';

import {
  IbmplexsansMediumElectricViolet20px,
  IbmplexsansMediumWhite16px,
  IbmplexsansNormalShark20px,
  IbmplexsansSemiBoldShark20px,
} from '../../styledMixins';

export const MoreOptionsWrapper = styled.div`
  position: absolute;
  right: 2px;
  top: 18px;
  display: inline-flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: 6px;
  border: 1px solid rgba(114, 0, 224, 0.1);
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(114, 0, 224, 0.1);
  z-index: 1;
`;

export const IconContainer = styled.img`
  position: relative;
  min-width: 20px;
  height: 20px;
`;

export const DeleteButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.3);
  }
`;

export const DeleteButtonContainerOnly = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const BubbleContainer = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  position: relative;
  margin-bottom: 7px;
  overflow: hidden;
`;

export const TagsWrapper = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const TaskTitle = styled.p`
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
  text-align: left;
  color: #7b7382;
`;

export const TaskTitleBold = styled.p`
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  text-align: left;
  color: #4b464f;
`;

export const Frame12191 = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  gap: 24px;
  position: relative;
`;

export const SLink = styled.div`
  ${IbmplexsansMediumElectricViolet20px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: right;
  letter-spacing: -0.5px;
  line-height: normal;
  cursor: pointer;
  &:hover {
    scale: 1.2;
    color: blue;
    text-decoration: underline;
  }
`;
export const Buttons1 = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  position: relative;
  background-color: var(--light-mode-purple);
  border-radius: 30px;
  border: 1px solid;
  cursor: pointer;
  &:hover {
    scale: 1.2;
    transition: 0.1s;
  }
`;

export const Button = styled.div`
  ${IbmplexsansMediumWhite16px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
`;

export const TaskLink = styled.a`
  text-decoration: none;
  font-family: IBM Plex Sans;
  font-size: 13px;
  font-weight: 600;
  line-height: 16.9px;
  text-align: center;
  color: var(--light-mode-purple);
  display: none !important;
  justify-content: center;
`;

export const StyledCard = styled.article`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  border: 2px solid rgb(223, 9, 9);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: ${({ exemplar, notification }) =>
    notification ? '16px' : exemplar ? '20px' : '12px'};
  position: relative;
  align-self: stretch;

  background-color: var(--white);
  box-shadow: ${({ exemplar, notification }) =>
    !exemplar && !notification
      ? '0 4px 16px rgba(156, 156, 156, 0.4)'
      : 'none'};

  box-shadow: ${({ notification }) =>
    notification ? 'none' : '0px 4px 8.5px 0px rgba(156, 156, 156, 0.08)'};
  border: ${({ notification, overdue }) =>
    notification
      ? 'none'
      : `1px solid ${overdue ? 'rgba(238, 149, 142, 1)' : '#EAEAEA'}`};
  border-radius: ${({ exemplar, notification }) =>
    notification ? 'none' : exemplar ? '6px' : '16px'};

  ${({ notification }) => notification && `border-bottom: 1px solid #F1E6FC;`}

  &:hover {
    background: ${({ exemplar, notification }) =>
      notification ? 'none' : exemplar ? 'inherit' : '#f1e6fc'};
    box-shadow: ${({ exemplar, notification }) =>
      exemplar || notification
        ? 'none'
        : '0px 4px 16px rgba(114, 0, 224, 0.2)'};
    ${TaskLink} {
      display: flex !important;
    }
  }
`;

export const StyledCardMain = styled.article`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  // padding: 20px;
  position: relative;
  align-self: stretch;
  // background-color: ${({ overdue }) =>
    overdue ? '#FDE2E2' : 'var(--white)'};
  // box-shadow: 0 4px 16px rgba(156, 156, 156, 0.4);
  // border-color: var(--corn);
  // border: 1px solid
  //   ${({ overdue }) => (overdue ? 'rgba(114, 0, 224, 0.10)' : '#EAEAEA')};
  // border-radius: ${({ overdue }) => (overdue ? '16px' : '0px')};;

  // &:hover {
  //   background: #f1e6fc;
  //   box-shadow: 0px 4px 16px rgba(114, 0, 224, 0.2);
  // }
`;

export const AnchorTag = styled.a`
  text-decoration: none;
`;

export const StudentLength = styled.span`
  color: var(--royal-purple);
  text-decoration: underline;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  position: relative;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClassTitle = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  color: var(--river-bed);
  font-weight: 400;
  font-size: var(--font-size-m);
  line-height: 18px;
`;

export const FavouriteContainer = styled.div`
  cursor: pointer;
`;

export const FavouriteContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${({ favourite }) =>
    favourite ? '#C70A65' : 'var(--light-mode-purple)'};
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: var(--font-size-s);
  line-height: 19px;
  transform: scale(1.1);
`;

export const StyledListItem = styled(ListItem)`
  padding: 4px 16px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #7200e0;
  font-size: 14px;
  font-family: IBM Plex Sans;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: ${props => props.$noHover ? 'none' : 'scale(1.1)'};
    background-color: ${props => props.$noHover ? 'rgba(114, 0, 224, 0.04)' : 'transparent'};
  }
`;

export const MultiSubjectBadgesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
  width: 100%;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  margin-top: 4px;

  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

export const ActionButton = styled.button`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 100px;
  border: 1px solid #7200e0;
  background: #fff;
  color: #7200e0;
  font-family: IBM Plex Sans;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;

  &:hover {
    background: #f1e6fc;
  }

  &:active {
    transform: scale(0.98);
  }

  img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  @media (max-width: 1400px) {
    width: 100%;
    white-space: normal;
    min-height: 36px;
    padding: 8px 16px;
  }
`;

export const GeneratingFeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-bottom: 1px solid #A7A7A740;
  padding: 0 12px 16px 12px;
  margin: 0 -12px;
`;
